import { RecallTimingPreference } from '@navio/nsdk';
import { type FilterOption } from 'noddi-ui-web';

export const TIRE_HOTEL_SEASON_SEGMENT_FILTER_OPTIONS: FilterOption<RecallTimingPreference>[] = [
  {
    value: RecallTimingPreference.EARLY,
    label: 'Early',
    icon: 'ArrowUp',
    description: 'Customers who typically change tires early in the season.'
  },
  {
    value: RecallTimingPreference.MID,
    label: 'Middle',
    icon: 'Circle',
    description: 'Customers who typically change tires in the middle of the season.'
  },
  {
    value: RecallTimingPreference.LATE,
    label: 'Late',
    icon: 'ArrowDown',
    description: 'Customers who typically change tires late in the season.'
  }
];
